export default "__VITE_ASSET__BG_W8bkg__"